import { Modal } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';

function ModalComponent({
  title,
  styles = null,
  visible,
  onOkFunction,
  onCancelFunction,
  children,
  okText = 'Confirmar',
  cancelText = 'Cancelar',
  cancelButtonProps = {},
  okButtonProps = {},
}) {
  return (
    <Modal
      styles={{ body: { overflowY: 'scroll', maxHeight: '60vh' } }}
      title={title}
      okText={okText}
      cancelText={cancelText}
      style={styles}
      onCancel={onCancelFunction}
      open={visible}
      onOk={onOkFunction}
      cancelButtonProps={cancelButtonProps}
      destroyOnHidden={true}
      okButtonProps={okButtonProps}
    >
        {children}
    </Modal>
  );
}

ModalComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onOkFunction: PropTypes.func.isRequired,
  onCancelFunction: PropTypes.func.isRequired,
  styles: PropTypes.object,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default ModalComponent;
